import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { homePathForUser } from '../utils/roles.js';
import { apiJson } from '../api/client.js';

export function AcceptInvitePage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const token = params.get('token') || '';
  const email = params.get('email') || '';

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const data = await apiJson('/api/portal-invite/accept', {
        method: 'POST',
        skipAuth: true,
        body: {
          token,
          email,
          password,
          password_confirmation: password2,
        },
      });
      setSession(data);
      navigate(homePathForUser(data.user), { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <h1>Create your password</h1>
        <p className="muted">Choose a password for {email}</p>
        <form onSubmit={onSubmit} className="stack">
          <label className="field">
            <span>Password</span>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </label>
          <label className="field">
            <span>Confirm password</span>
            <input type="password" value={password2} onChange={(e) => setPassword2(e.target.value)} required />
          </label>
          {error ? <p className="err">{error}</p> : null}
          <button type="submit" className="btn-primary" disabled={submitting}>
            {submitting ? 'Activating…' : 'Activate account'}
          </button>
        </form>
      </div>
    </div>
  );
}
